import Typography, { TypographyProps } from '@mui/material/Typography';
import { useTranslate } from 'react-admin';

export type TypographyTranslatedProps = Omit<TypographyProps, 'children'> & {
  label: string;
  variables?: Record<string, string>;
};

export function TypographyTranslated({ label, variables, ...props }: TypographyTranslatedProps) {
  const translate = useTranslate();
  return <Typography {...props}>{translate(label, variables)}</Typography>;
}
